import AppLanguages from './AppLanguages.container';

export default AppLanguages;
